<template>
  <div id="special-discount-helper" :class="['bg-light rounded', classes]">
    <p class="helper-header d-flex align-items-center mb-2">
      <img src="@/assets/images/info-neutral.svg" alt="info" class="mr-2">
      {{ specialDiscountData.header }}
    </p>
    <p class="mb-0">{{ specialDiscountData.message }}</p>
  </div>
</template>

<script>
export default {
  name: "SpecialDiscountNotApplied",
  props: {
    idType: {
      type: String,
      default: "Senior Citizen"
    },
    classes: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      specialDiscountData: {
        header: "Discount Not Applied",
        message: `The ${this.idType} ID was not approved as it did not meet the requirements.`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#special-discount-helper {
  padding: 16px 24px;
  margin-top: 24px;
  background: #F8F9F9;

  p {
    font-size: 14px;

    &.helper-header {
      font-size: 16px;
      @extend .mainFontBold;
    }
  }
}
</style>
